import Marquee from "react-fast-marquee";
import { Diya, Marigold } from "./motifs";

const ITEMS = [
    "Handmade. Heartmade.",
    "Every Celebration, Styled Just Right",
    "Traditional Indian Charm for Modern Homes",
    "Crafted in Point Cook, Loved Australia-wide",
];

const EditorialMarquee = () => (
    <div
        className="relative border-y border-[#472500]/15 bg-[#472500] text-[#F0EEE8] py-6 overflow-hidden"
        data-testid="editorial-marquee"
        aria-hidden="true"
    >
        <Marquee speed={28} gradient={false} pauseOnHover>
            {ITEMS.map((text, i) => (
                <span key={i} className="flex items-center">
                    <span className="font-display italic text-2xl sm:text-3xl tracking-wide px-8 whitespace-nowrap">
                        {text}
                    </span>
                    {i % 2 === 0 ? (
                        <Diya className="w-8 h-8 text-[#E2BA03]" />
                    ) : (
                        <Marigold className="w-8 h-8 text-[#E2BA03]" />
                    )}
                </span>
            ))}
        </Marquee>
    </div>
);

export default EditorialMarquee;
